import { useState } from 'react';
import type { MouseEvent } from 'react';
import { useCurrentUser } from '../../../../hooks/useCurrentUser';

export const useUserMenu = () => {
    const { currentUser } = useCurrentUser();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleMenuOpen = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return {
        anchorEl,
        currentUser,
        handleMenuClose,
        handleMenuOpen,
        isMenuOpen: Boolean(anchorEl),
    };
};
